import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';
import { SegmentChangeHistoryState } from './segmentChangeHistory.types';

// Base selector
const selectSegmentChangeHistoryState = (
  state: RootState
): SegmentChangeHistoryState => state.segmentChangeHistory;

// Memoized selectors
export const selectChangeHistory = createSelector(
  [selectSegmentChangeHistoryState],
  (segmentChangeHistoryState) => segmentChangeHistoryState.changeHistory
);

export const selectChangeHistoryLoading = createSelector(
  [selectSegmentChangeHistoryState],
  (segmentChangeHistoryState) => segmentChangeHistoryState.loading
);

export const selectChangeHistoryError = createSelector(
  [selectSegmentChangeHistoryState],
  (segmentChangeHistoryState) => segmentChangeHistoryState.error
);

export const selectChangeHistorySuccess = createSelector(
  [selectSegmentChangeHistoryState],
  (segmentChangeHistoryState) => segmentChangeHistoryState.success
);
